import Header from '../../../components/Header'
import { Filtro } from './components/Filtro'
import { Layout } from './components/Layout'
import { Title } from './components/Title'
import { Vendas } from './components/Vendas'
import Produtos from './components/Produtos'
import { MarkupProvider } from './contexts/MarkupProvider'

export function Markup() {
  return (
    <MarkupProvider>
      <Layout>
        <Title>Markup Innovation Brindes</Title>
        <Filtro />
        <Vendas />

        {/* <Suspense fallback={"Carregando gráficos..."}>
          <Graphics />
        </Suspense> */}
        <Produtos />
      </Layout>
    </MarkupProvider>
  )
}
